<template>
  <div class="main-content">
    <avue-crud ref="crud" :data="tableData" :option="option" :table-loading="showLoading" :page.sync="page"
      @on-load="onLoad" @selection-change="selectionChange">
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">用户ID :
              </span>
              <div class="width300">
                <el-input v-model="searchData.userId" placeholder="请输入" clearable maxlength="50"></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">用户昵称 :
              </span>
              <div class="width300">
                <el-input v-model="searchData.nickname" placeholder="请输入" clearable maxlength="50"></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">手机号码 :
              </span>
              <div class="width300">
                <el-input v-model="searchData.phone" placeholder="请输入" clearable maxlength="11"></el-input>
              </div>
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">访问时间 :
              </span>
              <div class="width300">
                <el-date-picker v-model="searchData.createTime" type="daterange" range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期" :clearable="true">
                  <!-- @change="handleSearch" -->
                </el-date-picker>
              </div>
            </div>
            <el-button size="medium" type="primary" @click="handleSearch" style="margin-bottom: 10px"
              class="marginLeft10">搜索</el-button>
            <el-button size="medium" type="info" @click="handleReset" style="margin-bottom: 10px"
              class="marginLeft10 marginRight10">重置</el-button>
            <div class="flex align-items marginRight10 marginBottom10">
              <el-button size="medium" type="primary" @click="handleCreate">新增</el-button>
            </div>
            <!-- <div class="flex align-items marginRight10 marginBottom10">
              <el-button
                type="danger"
                size="medium"
                @click="handleDeletes([...selectedRowKeys])"
                >删除</el-button
              >
            </div> -->
          </div>
        </div>
      </template>
      <template slot="avatarUrl" slot-scope="{ row }">
        <el-image style="width: 50px; height: 50px" :src="row.avatarUrl" :preview-src-list="[row.avatarUrl]">
        </el-image>
      </template>
      <template slot="serviceState" slot-scope="{ row }">
        <div>
          {{
            row.serviceState == ESex.NotOpened
              ? MSex[row.serviceState]
              : row.serviceState == ESex.Opened
                ? MSex[row.serviceState]
                : row.serviceState == ESex.Expired
                  ? MSex[row.serviceState]
                  : ""
          }}
        </div>
      </template>
      <template slot="groupNum" slot-scope="{ row }">
        <div style="color: #00d8c3; cursor: pointer" @click="getJump('/user/group', row, '分组管理')">
          {{ row.groupNum }}
        </div>
      </template>
      <template slot="gatewayNum" slot-scope="{ row }">
        <div style="color: #00d8c3; cursor: pointer" @click="getJump('/user/gateway', row, '网关管理')">
          {{ row.gatewayNum }}
        </div>
      </template>
      <template slot="deviceNum" slot-scope="{ row }">
        <div style="color: #00d8c3; cursor: pointer" @click="getJump('/device/manage', row, '设备列表')">
          {{ row.deviceNum }}
        </div>
      </template>

      <template slot="menu" slot-scope="{ row }">
        <!-- <el-button
          type="text"
          size="mini"
          icon="el-icon-view"
          @click="handleDetails(row)"
          >详情</el-button
        > -->
        <el-button type="text" size="mini" @click="handleView(row)">详情</el-button>
        <el-button type="text" size="mini" @click="handleEdit(row)">编辑</el-button>
        <el-button type="text" size="mini" @click="handleVip(row)">增值服务</el-button>
        <!-- <el-button
          type="text"
          size="mini"
          @click="handleDelete([row])"
          style="color: #ff001f !important"
          >删除</el-button
        > -->
      </template>
    </avue-crud>
    <el-dialog v-if="dialogVisible" :title="`${viewShow ? '详情' : form.id ? '修改用户' : '新增用户'}`"
      :visible.sync="dialogVisible" width="40%" :before-close="handleClose" :close-on-click-modal="false">
      <avue-form ref="form" v-model="form" :option="formOption">
        <template slot="avatarUrl">
          <FormImgUpload :url="form.avatarUrl" @upload="upload" :limit="1" :maxSize="2" accept=".png,.jpg"
            :multiple="true" :disabled="viewShow" />
          <div style="color: #c0c1c3">
            建议尺寸：60px*60px，图片格式：.png，.jpg
          </div>
        </template>

        <template slot="menuForm">
          <el-button @click="handleClose">取消</el-button>
          <el-button v-if="!viewShow" type="primary" :loading="showLoadingForm" @click="submit(form)">确认</el-button>
        </template>
      </avue-form>
    </el-dialog>
    <!-- 增值服务弹窗 -->
    <el-dialog v-if="vipDialogVisible" :title="'增值服务'" :visible.sync="vipDialogVisible" width="40%"
      :before-close="handleVipDialogClose" :close-on-click-modal="false">
      <div>
        <div style="margin-bottom: 20px;">请选择增值服务结束时间</div>
        <el-date-picker v-model="vipData.serverEndTime" type="datetime" value-format="yyyy-MM-dd hh:mm:ss">
        </el-date-picker>
      </div>
      <div style="text-align: right;; margin-top: 20px;">
        <el-button @click="handleVipDialogClose">取消</el-button>
        <el-button type="primary" :loading="showLoadingForm" @click="submitVip">确认设置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  manageList,
  manageAdd,
  managemDelete,
  managemDeletes,
  manageUpdate,
  manageSetVip,
} from "@/api/user/manage";
import dayjs from "dayjs";
import FormImgUpload from "@/components/formComponents/formImgUpload";
import { emailRegex, mobilePhoneRule } from "@/utils/formRules";
import { ESex, MSex } from "@/enums/beCurrent/EBeCurrent";
export default {
  name: "index",
  components: {
    FormImgUpload,
  },
  data() {
    return {
      searchData: {
        title: "",
        createTime: "",
      },
      vipData: {
        id: "",
        serverEndTime: "",
      },
      page: {
        total: 0,
        currentPage: 1,
      },
      ESex: ESex,
      MSex: MSex,
      tableData: [],
      showLoading: false,
      showLoadingForm: false,
      dialogVisible: false,
      selectedRowKeys: [], //表格勾选中的数据
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        selection: false,
        reserveSelection: true,
        selectionFixed: true,
        tip: false,
        column: [
          {
            label: "用户ID",
            prop: "userId",
          },
          {
            label: "用户头像",
            prop: "avatarUrl",
            width: 150,
          },
          {
            label: "昵称",
            prop: "nickname",
          },
          {
            label: "手机号",
            prop: "phone",
            width: 150,
          },
          {
            label: "增值服务",
            prop: "serviceState",
          },
          {
            label: "增值服务到期时间",
            prop: "serviceEndTime",
            width: 150,
          },
          {
            label: "分组",
            prop: "groupNum",
          },
          {
            label: "网关",
            prop: "gatewayNum",
          },
          {
            label: "设备",
            prop: "deviceNum",
          },
          {
            label: "邮箱",
            prop: "email",
            width: 150,
          },
          {
            label: "最近访问",
            prop: "recentVisitTime",
            width: 150,
          },
          {
            label: "注册时间",
            prop: "createTime",
            width: 150,
          },
        ],
      },

      dialogVisible: false,
      vipDialogVisible: false,
      form: {
        id: "",
        avatarUrl: [],
      },
      formOption: {
        submitBtn: false,
        submitText: "确定",
        emptyBtn: false,
        labelWidth: "100",
        row: true,
        column: [
          {
            label: "用户头像",
            prop: "avatarUrl",
            type: "text",
            maxlength: 50,
            span: 24,
            // rules: [
            //   {
            //     required: true,
            //     message: "请上传",
            //     trigger: "blur",
            //   },
            //   {
            //     validator: (rule, value, callback) => {
            //       if (value.length === 0) {
            //         callback(new Error("请上传"));
            //       } else {
            //         callback();
            //       }
            //     },
            //   },
            // ],
          },
          {
            label: "用户昵称",
            prop: "nickname",
            // type: "text",
            maxlength: 8,
            span: 16,
            row: true,
            placeholder: "请输入",
            rules: [
              {
                required: true,
                message: "请输入名称",
                trigger: "blur",
              },
            ],
          },
          {
            label: "手机号",
            prop: "phone",
            // type: "text",
            maxlength: 11,
            span: 16,
            row: true,
            placeholder: "请输入",
            rules: [
              {
                required: true,
                message: "请输入手机号",
                trigger: "blur",
              },
              ...mobilePhoneRule,
            ],
          },
          {
            label: "邮箱",
            prop: "email",
            maxlength: 100,
            span: 16,
            row: true,
            placeholder: "请输入",
            rules: [
              // {
              //   required: true,
              //   message: "请输入邮箱",
              //   trigger: "blur",
              // },
              ...emailRegex,
            ],
          },
          {
            label: "密码",
            prop: "password",
            maxlength: 20,
            span: 16,
            type: "password",
            // showWordLimit: true,
            row: true,
            placeholder: "请输入",
            rules: [
              {
                required: true,
                message: "请输入密码",
                trigger: "blur",
              },
              {
                validator(_, value) {
                  if (value) {
                    if (value.length < 6) {
                      return Promise.reject(new Error("最少6位"));
                    }
                  }
                  return Promise.resolve(true);
                },
              },
            ],
          },
        ],
      },
      viewShow: false, //是否是详情
    };
  },
  created() { },
  methods: {
    onLoad() {
      this.showLoading = true;
      const searchData = {
        ...this.searchData,
      };
      if (this.searchData.createTime) {
        searchData.visitTimeStart = dayjs(this.searchData.createTime[0]).format(
          "YYYY-MM-DD 00:00:00"
        );
        searchData.visitTimeEnd = dayjs(this.searchData.createTime[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      delete searchData.createTime;
      manageList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      // console.log('重置')
      this.searchData = {
        state: "",
        name: "",
        createTime: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 添加
    handleCreate() {
      this.form = {
        avatarUrl: [],
        id: "",
      };
      this.replacePassword(true);
      this.viewShow = false;
      this.replaceDis(false);
      this.dialogVisible = true;
    },
    // 关闭
    handleClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.resetForm();
      }, 500);
    },
    //编辑
    async handleEdit(row) {
      this.viewShow = false;
      this.replacePassword(true);
      this.form.id = row.id;
      this.replaceDis(false);
      this.dialogVisible = true;
      this.form = { ...row, avatarUrl: row.avatarUrl ? [row.avatarUrl] : [] };
    },
    //升级会员按键点击
    handleVip(row) {
      console.log('open vip', row)
      this.vipDialogVisible = true
      this.vipData.id = row.id
      this.vipData.serverEndTime = row.serviceEndTime
    },
    //关闭升级会员弹窗
    handleVipDialogClose() {
      this.vipDialogVisible = false
    },
    //升级会员提交
    submitVip() {
      console.log('submit vip', this.vipData)
      if (!(this.vipData.serverEndTime)) {
        this.$message.error("请选择增值服务结束时间");
      }
      manageSetVip(this.vipData).then((res) => {
        if (res.code === 200) {
          this.$message.success("操作成功");
          this.handleVipDialogClose()
        }
        this.onLoad()
      })
    },
    //详情
    handleView(row) {
      this.replacePassword(false);
      this.viewShow = true;
      this.form.id = row.id;
      this.replaceDis(true);
      this.dialogVisible = true;
      this.form = { ...row, avatarUrl: row.avatarUrl ? [row.avatarUrl] : [] };
    },
    //切换
    replaceDis(show) {
      const nickname = this.findObject(this.formOption.column, "nickname");
      nickname.disabled = show;
      const phone = this.findObject(this.formOption.column, "phone");
      phone.disabled = show;
      const email = this.findObject(this.formOption.column, "email");
      email.disabled = show;
    },
    replacePassword(show) {
      const password = this.findObject(this.formOption.column, "password");
      password.display = show;
    },

    // 删除
    handleDelete(row) {
      // console.log('删除',row)
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        managemDelete({
          id: row.map((obj) => obj.id).join(","),
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功!");
            console.log(row, "rowrowrowrow");
            this.$refs.crud.toggleSelection();
            this.onLoad();
          }
        });
      });
    },
    // 批量删除
    handleDeletes(row) {
      if (!row.length) {
        this.$message.error("至少选择一个");
        return;
      }
      // console.log('删除',row)
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        managemDeletes({
          id: row.map((obj) => obj.id).join(","),
        }).then((res) => {
          if (res.code === 200) {
            // this.$message.success("删除成功!");
            console.log(row, "rowrowrowrow");
            this.$refs.crud.toggleSelection();
            this.onLoad();
          }
        });
      });
    },

    //表格左侧选择的数据的
    selectionChange(list) {
      this.selectedRowKeys = list;
      // console.log('选中的数据',list);
      // this.$message.success('选中的数据'+ JSON.stringify(list));
    },

    // 提交
    submit(form) {
      this.$refs.form.$refs.form.validate((valid, done) => {
        if (valid) {
          if (this.showLoadingForm) {
            return;
          }
          this.showLoadingForm = true;
          console.log(form, "formformform");
          // return
          if (form.id) {
            manageUpdate({
              ...form,
              avatarUrl:
                form.avatarUrl && form.avatarUrl.length > 0
                  ? form.avatarUrl[0]
                  : "",
            })
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success("操作成功");
                  this.dialogVisible = false;
                  setTimeout(() => {
                    this.resetForm();
                  }, 500);
                  this.onLoad();
                  this.showLoadingForm = false;
                } else {
                  // this.$message.error(res.msg);
                  this.showLoadingForm = false;
                  done();
                }
              })
              .catch(() => (this.showLoadingForm = false));
          } else {
            manageAdd({
              ...form,
              avatarUrl:
                form.avatarUrl && form.avatarUrl.length > 0
                  ? form.avatarUrl[0]
                  : "",
            })
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success("操作成功");
                  this.dialogVisible = false;
                  setTimeout(() => {
                    this.resetForm();
                  }, 500);
                  this.onLoad();
                  this.showLoadingForm = false;
                } else {
                  // this.$message.error(res.msg);
                  this.showLoadingForm = false;
                  done();
                }
              })
              .catch(() => (this.showLoadingForm = false));
          }
          // this.form.type = 1;
          // done()
        }
      });
    },
    //富文本框变化替换值
    editoChange(e) {
      this.form.details = e;
    },
    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },
    //图片上传
    upload(e) {
      if (Array.isArray(e)) {
        this.form.avatarUrl = [...e];
      } else {
        this.form.avatarUrl = [...this.form.avatarUrl, e];
      }
    },

    //跳转页面列表
    getJump(url, row, name) {
      // let url = "/user/group";
      const indexof = this.$globalMethod(url);
      this.$root.eventHub.$emit("changeSubMenuIndex", String(indexof));
      // this.$store.commit("setSubMenuIndex", String(obj.indexof));
      if (url != this.$store.state.index.router) {
        this.$router.push({ path: url, query: { id: row.userId } });
        let tableTabs = this.$store.state.index.tableTabs;
        let data = {
          title: name,
          name: "0",
          url: url,
          index: this.$store.state.index.SubMenuIndex,
        };
        let exist = false;
        tableTabs.forEach((item) => {
          if (item.title == data.title) {
            data.name = item.name;
            exist = true;
          }
        });
        if (!exist) {
          tableTabs.forEach((item, index) => {
            if (index + 1 == tableTabs.length) {
              data.name = (item.name * 1 + 1).toString();
            }
          });
        }
        // console.log(exist, data, "xxxxxxxx");
        this.$root.eventHub.$emit("changeTableTabs", { type: exist, data });
      }
    },
  },
};
</script>

<style scoped></style>
